import React from 'react';
export default function Paginator({options, limitOnChange, offsetOnChange, count, limit, offset}) {
    const safeLimit = Number.parseInt(limit, 10) > 0 ? Number.parseInt(limit, 10) : 1;
    const safeOffset = Number.parseInt(offset, 10) > 0 ? Number.parseInt(offset, 10) : 0;
    const safeCount = Number.parseInt(count, 10) > 0 ? Number.parseInt(count, 10) : 0;
    const totalPages = safeCount > 0 ? Math.ceil(safeCount / safeLimit) : 1;
    const disablePaging = totalPages <= 1;
    const lastOffset = Math.max(0, (totalPages - 1) * safeLimit);
    const paginatorButtons = [];
    const startPaginationValue = Math.floor(safeOffset / safeLimit) > 2 ? Math.floor(safeOffset / safeLimit) - 1 : 1;
    for (let i = startPaginationValue; (i - 1) < safeCount / safeLimit; i++) {
        paginatorButtons.push(i);
        if (paginatorButtons.length > 4) {break;}
    }
    function setOffset(type) {
        if (disablePaging) return;
        let newOffset = 0;
        switch(type) {
            case 'first':
                newOffset = 0;
                break;
            case 'last':
                newOffset = lastOffset;
                break;
            case 'prev':
                newOffset = (safeOffset > safeLimit) ? (safeOffset - safeLimit) : 0;
                break;
            case 'next':
                newOffset = (safeOffset + safeLimit < safeCount) ? (safeOffset + safeLimit) : lastOffset;
                break;
            default:
                newOffset = safeOffset;
        }
        offsetOnChange(newOffset);
    }

    return (
        <div className="col-sm-12 col-md-7 dataTables_pager d-flex flex-row align-content-center justify-content-end">
            {options && options.length > 0 && 
                <div className="dataTables_length  d-flex flex-row ">
                    <label className="d-flex flex-row align-items-center  ml-5 mr-5">
                        Show
                        <select
                            onChange={(event) => limitOnChange(event)}
                            name="m_table_1_length"
                            aria-controls="m_table_1"
                            style={{width:'46px'}}
                            value={limit}
                            className="custom-select custom-select-sm form-control form-control-sm ml-2 mr-2 ">
                            {options.map(option => <option key={option.text} value={option.value}>{option.text}</option>)}
                        </select>
                        entries
                    </label>
                </div>
            }
            <div className="dataTables_paginate paging_simple_numbers">
                <ul className="pagination m-0">
                    <li className={`paginate_button page-item previous${disablePaging ? " disabled" : ""}`}>
                        <button
                            type="button"
                            disabled={disablePaging}
                            onClick={() => setOffset('first')}
                            aria-controls="m_table_1"
                            aria-disabled={disablePaging}
                            style={disablePaging ? { pointerEvents: "none", opacity: 0.5, cursor: "not-allowed" } : undefined}
                            className="page-link">
                            <i className="la la-angle-double-left"/>
                        </button>
                    </li>
                    {paginatorButtons.map(offsetValue => {
                        const pageOffset = safeLimit * (offsetValue - 1);
                        return (
                            <li key={offsetValue}
                                className={"paginate_button page-item " + (pageOffset === safeOffset ? 'active' : '') + (disablePaging ? ' disabled' : '')}>
                            <button
                                type="button"
                                key={offsetValue}
                                disabled={disablePaging}
                                aria-controls="m_table_1"
                                aria-disabled={disablePaging}
                                style={disablePaging ? { pointerEvents: "none", opacity: 0.5, cursor: "not-allowed" } : undefined}
                                onClick={() => {
                                    if (disablePaging) return;
                                    offsetOnChange(pageOffset);
                                }}
                                className="page-link">{offsetValue}</button>
                        </li>);
                    })}
                    <li className={`paginate_button page-item next${disablePaging ? " disabled" : ""}`}>
                        <button
                            type="button"
                            disabled={disablePaging}
                            onClick={() => setOffset('last')}
                            aria-controls="m_table_1"
                            aria-disabled={disablePaging}
                            style={disablePaging ? { pointerEvents: "none", opacity: 0.5, cursor: "not-allowed" } : undefined}
                            className="page-link">
                            <i className="la la-angle-double-right"/>
                        </button>
                    </li>
            </ul>
        </div>
    </div>)
}
